// Hardcoded invoiceDescription options; more balance types will be added here later.
export const INVOICE_DESCRIPTION_OPTIONS = [
    {value: 'pedalCourtInvoiceBalance', label: 'Pedal Court Invoice Balance'},
];

const createGenericInvoiceModel = {
    formId: 'genericItemForm',
    formField: {
        totalCost: {
            name: 'totalCost',
            label: 'Total Cost',
        },
        development: {
            name: 'development',
        },
        type: {
            name: 'type',
        },
        phase: {
            name: 'phase',
        },
        invoiceDescription: {
            name: 'invoiceDescription',
            label: 'Invoice Description',
            required: true,
            requiredErrorMsg: 'Invoice description is required',
        },
        dueDate: {
            name: 'dueDate',
            label: 'Due Date',
        },

        items: {
            name: 'items',
            label: ' Items',
            required: true,
            requiredErrorMsg: 'At least one item is required',
            fields: {
                description: {
                    name: 'description',
                    label: 'Description',
                    required: true,
                    requiredErrorMsg: 'Description is required',
                },
                quantity: {
                    name: 'quantity',
                    label: 'Quantity',
                    required: true,
                    requiredErrorMsg: 'Quantity is required',
                },
                unitPrice: {
                    name: 'unitPrice',
                    label: 'Unit Price',
                    required: true,
                    requiredErrorMsg: 'unitPrice is required',
                },
                totalCostPerItem: {
                    name: 'totalAmount',
                    label: 'Total Amount',
                    required: true,
                    requiredErrorMsg: 'Total Amount is required',
                },
            },
        },
    },
    initialValues: {
        totalCost: 0,
        development: '',
        type: '',
        phase: '',
        invoiceDescription: '',
        dueDate: null,
        items: [{
            description: '',
            quantity: 0,
            unitPrice: 0,
            totalCostPerItem: 0
        }],
    },
};

export default createGenericInvoiceModel;
